
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/page",
      function () {
        return require("private-next-pages/node/page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/page"])
      });
    }
  